import '@/locales';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { Price, Discount } from '@/legacy/api/class.Common';
import { Time } from '@/legacy/api/class.OperatingHours';

const {
    app: { language, language_bundle },
    helpers: { capitalise },
} = Mobi2Go;

i18n.use(initReactI18next).init({
    fallbackLng: 'en',
    debug: false,
    interpolation: {
        format(value, format /* , lng */) {

            if (moment.isDate(value) || moment.isMoment(value)) {
                return moment(value).format(format);
            }
            if (value instanceof Time) {
                return value.format(format);
            }
            if (value instanceof Price || value instanceof Discount) {
                return value.format(format);
            }
            if (format === 'lowercase') {
                return value.toLowerCase();
            }
            if (format === 'capitalise') {
                return capitalise(value);
            }

            // Slice a value
            const sliceMatch = format.match(/^slice\((-?\d+(,\s?-?\d+)?)\)$/);

            if (sliceMatch && sliceMatch[1]) {
                return String(value).slice(eval(sliceMatch[1]));
            }

            return value;
        },
    },
    lng: Mobi2Go.app.language,
    resources: {
        [language]: language_bundle,
    },
});

export const isDefaultLanguage = () => {
    const params = new URLSearchParams(window.location.search);
    const languageParam = params.get('language');
    return (
        !languageParam || languageParam === Mobi2Go.headoffice.languages[0].tag
    );
};

export const resetLanguage = () => {
    const params = new URLSearchParams(window.location.search);
    if (!isDefaultLanguage()) {
        params.delete('language');
        window.location.search = params.toString();
    }
};
